// ETG identifies each tax/fee line with a raw machine code (e.g. "city_tax",
// "service_fee") meant for API consumers, not guests. Every screen that lists
// a property-payable tax must go through this instead of showing `tax.name`
// verbatim — a single seam, so a new code ETG introduces later reads sensibly
// everywhere without needing a matching code change at each display site.
const TAX_NAME_OVERRIDES: Record<string, string> = {
  vat: 'VAT',
};

export function formatTaxName(name: string | null | undefined): string {
  const key = (name ?? '').trim().toLowerCase();
  if (!key) return 'Local fee';
  if (TAX_NAME_OVERRIDES[key]) return TAX_NAME_OVERRIDES[key];

  return key
    .split(/[_\s]+/)
    .filter(Boolean)
    .map((word, index) => (index === 0 ? word.charAt(0).toUpperCase() + word.slice(1) : word))
    .join(' ');
}
